import { makeStyles } from '@shared/theme';
import { ComponentProps } from 'react';
import SpriteFlag from './SpriteFlag';
import sprites from './sprites';
import sprites1x from './sprites@1x.png';
import sprites2x from './sprites@2x.png';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    backgroundImage: `url(${sprites1x})`,
    '@media (min-resolution: 200dpi)': {
      backgroundImage: `url(${sprites2x})`,
    },
    '&[data-country=""]': {
      backgroundColor: palette.neutrals[600],
    },
    '&:not([data-country=NP]):not([data-country=""])': {
      // some Android versions have a weird bug, where the background image is
      // only shown if there's a border
      // boxShadow: `0 0 1px 1px ${palette.neutrals[600]}`,
      border: `1px solid ${palette.neutrals[600]}`,
    },
  },
}));

type Props = Omit<ComponentProps<typeof SpriteFlag>, 'offset' | 'sprites'> & { code: string };

const CountryFlag: FC<Props> = ({ code, className, ...restProps }) => {
  const { classes, cx } = useStyles();
  const offset = (sprites as string[]).indexOf(code.toUpperCase());
  return (
    <SpriteFlag
      className={cx(classes.root, className)}
      sprites={sprites.length}
      offset={offset}
      data-country={code.toUpperCase()}
      {...restProps}
    />
  );
};

export default CountryFlag;
